module.exports = __webpack_public_path__ + "static/nonHeadingNo-ba9ce3ac63f0346655ee35c035a5c9d0.png";